"use client";

import Link from "next/link";
import { trackClickEvent } from "@/lib/tracking";

export default function HomeCTAs() {
  function handleCtaClick(label: string, href: string) {
    if (typeof window !== "undefined") {
      trackClickEvent("home_cta_click", href, label);
    }
  }

  return (
    <div className="mt-6 flex flex-wrap gap-3 text-sm">
      <Link
        href="/contact"
        className="rounded-full bg-blue-600 px-5 py-2 font-semibold text-white shadow hover:bg-blue-500"
        onClick={() => handleCtaClick("Book a discovery call", "/contact")}
      >
        Book a discovery call
      </Link>
      <Link
        href="/products"
        className="rounded-full border border-slate-600 bg-slate-950/50 px-5 py-2 text-slate-200 hover:border-blue-500 hover:text-blue-200"
        onClick={() => handleCtaClick("Explore our agents", "/products")}
      >
        Explore our agents
      </Link>
    </div>
  );
}
